import { api } from '@services';
import { AxiosError, AxiosResponse } from 'axios';
import Field, { IField, IFieldApiModel } from '@models/Field.model';
import AppError from '@utils/AppError';
import { Result } from '@utils/index';

interface IPatchField {
  content?: string | Date | null;
  equipmentId?: string;
  softwareId?: string;
  studioServiceId?: string;
  miscellaneousId?: string;
}
interface IPatchRequest {
  customFieldId: string;
  data: IPatchField;
}
interface TError {
  status: string;
  message: string;
}
type IResponse = AxiosResponse<IFieldApiModel>;
export type UpdateContentError = AxiosError<TError>;
const updateCustomFieldContent = async ({
  customFieldId,
  data,
}: IPatchRequest): Promise<IField> => {
  const axiosResponse = api.put<IFieldApiModel>(
    `/customFields/${customFieldId}/content`,
    data,
  );

  const result = await Result.asyncCatch<UpdateContentError, IResponse>(
    axiosResponse,
  );

  const result_map = Result.mapErr(result, toUniqueFieldsErr);
  if (result_map.is_ok) {
    return Field.fromApiModel(result_map.data.data);
  }
  throw result_map.error;
};

export { updateCustomFieldContent };

export function toUniqueFieldsErr(
  err: UpdateContentError,
): UpdateContentError | AppError {
  if (err.response && err.response.status === 409) {
    const { response } = err;

    return new AppError(response.data.message, 409);
  }
  return err;
}
